import Drawer from "@material-ui/core/Drawer";
import styled from 'styled-components';

const mainFont = 'Open Sans, sans-serif';

export const StyledDrawer = styled(Drawer)`
  .sidebar {
    &__arrow-bar {
      height: 45px;
      width: 45px;
    }
  }

  .sidebar-menu {
    padding: 15px 0 0;
    overflow-x: hidden;
    overflow-y: auto;
    overflow-scrolling: touch;

    &::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 3px;
      height: 0;
      background-color: #F5F4FA;
      display: none;
    }

    &::-webkit-scrollbar-thumb {
      border-radius: 2px;
      background-color: #b9bccc;
      display: none;
    }

    &:hover {
      &::-webkit-scrollbar {
        display: block;
      }

      &::-webkit-scrollbar-thumb {
        display: block;
      }
    }

    &__item {
      padding: 16px 18px;
      
      &:hover {
        background-color: #F5F4FA;
      }

      @media screen and (max-width: 599px) {
        padding: 10px 18px;
      }
    }

    &__text span {
      color: #909090;
      font-family: ${mainFont};
      font-size: 16px;
      font-weight: 600 !important;
      
      @media screen and (max-width: 599px) {
        font-size: 14px;
      }
    }

    &__icon {
      padding-left: 5px;
      font-size: 24px;
      @media screen and (max-width: 960px) {
        padding-left: 0;
        font-size: 22px;
      }
      @media screen and (max-width: 599px) {
        min-width: 45px;
      }
    }

    .active {
      background: #F5F4FA;
      position: relative;

      .sidebar-menu__text span {
        color: #277661;
      }

      .sidebar-menu__icon {
        color: #277661;
      }

      &:after {
        content: '';
        height: 100%;
        width: 5px;
        background: linear-gradient(100deg, #277661 -20.66%, #29DEAE 68.48%);
        border-radius: 5px;
        position: absolute;
        right: 0;
        top: 0;
      }
    }
  }
  
  @media screen and (max-width: 992px) {
    position: absolute;
    top: 0;
    left: 0;
  }
`;

export const StyledDivider = styled.div`
  height: 50px;
  @media screen and (max-width: 599px) {
    height: 25px;
  }
`;

export const StyledDrawerOpen = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 8px;
  transition: all .3s ease;
  @media screen and (max-width: 992px) {
    padding: 0 13px;
  }
`;

export const StyledSidebarLogo = styled.button`
  width: 100%;
  display: grid;
  grid-template-columns: 45px 1fr;
  grid-gap: 5px;
  align-items: end;
  .sidebar-logo__icon {
    width: 45px;
    padding-bottom: 5px;
  }
  .sidebar-logo__title {
    color: #162954;
    font-family: ${mainFont};
    font-size: 22px;
    font-weight: 800;
    text-align: left;
    //@media screen and (max-width: 599px) {
    //  font-size: 18px;
    //}
  }

  @media screen and (max-width: 992px) {
    grid-template-columns: 30px 1fr;
    .sidebar-logo__icon {
      width: 30px;
    }
  }
`;
